import { render } from "./PayerTable.vue?vue&type=template&id=00134576&ts=true"
import script from "./PayerTable.ts?vue&type=script&lang=ts&external"
export * from "./PayerTable.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__